const latestPosts = [
  {
    title: "Women's Day",
    description:
      "From nurturing families to leading nations, women can do it all. Today, we celebrate the strength, resilience and achievements of the heartbeat of humanity. To all the incredible women who make the world a better place, Happy International Women's Day!!!",
    image_link: require("../assets/images/latestPosts/womens-day.jpg"),
    domain: "Community",
    date: "March 8, 2024",
    link: "https://www.instagram.com/p/C4PPt8YBdH_/?igsh=MTF4MXptZDdvOGd2cQ==",
    type: "Read",
  },
  {
    title: "Introduction to Automation",
    description:
      "Unlocking the Magic of Automation: From Sensors to Software, Explained! ✨",
    image_link: require("../assets/images/latestPosts/automation-intro.jpg"),
    domain: "Community",
    date: "March 3, 2024",
    link: "https://www.instagram.com/p/C4FGI3QBEPf/?igsh=cGd4emljc3QwdW9s",
    type: "Read",
  },
  {
    title: "Black Day",
    description:
      "Amidst the roses, a touch of somber hues on February 14th – a black day that whispers stories of strength and resilience within the folds of love's tapestry. #blackday",
    image_link: require("../assets/images/latestPosts/black-day.jpg"),
    domain: "Community",
    date: "Feburary 14, 2024",
    link: "https://www.instagram.com/p/C3U0qtnBv-h/?igsh=MWJndTV2eTQ4ZGJ1ag==",
    type: "Read",
  },
];

export default latestPosts;
